import { LOGOUT } from 'app/ducks/auth/types'
import * as types from './types'

// status: 'idle' | 'loading' | 'loaded' | 'error'
const initialState = {
  status: 'idle',
  items: [],
}

const internalCampaignsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_INTERNAL_CAMPAIGNS:
      return { ...state, status: 'loading' }

    case types.FETCH_INTERNAL_CAMPAIGNS_SUCCESS:
      return { status: 'loaded', items: action.payload }

    case types.FETCH_INTERNAL_CAMPAIGNS_ERROR:
      return { ...state, status: 'error' }

    case types.MARK_INTERNAL_CAMPAIGN_SEEN:
      return {
        ...state,
        items: state.items.map((campaign) =>
          campaign.id === action.payload
            ? { ...campaign, is_new: false }
            : campaign
        ),
      }

    // Campaigns (and whether each one is new) are per user.
    case LOGOUT:
      return initialState

    default:
      return state
  }
}

export default internalCampaignsReducer
